import React, { useEffect } from "react";
import { getPlanDetail } from '../../../slices/plans'
import { getPlanGroups } from '../../../slices/plangroups'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import PlanForm from "../../../components/forms/plan-form";

const PlanCreate = () => {

    const dispatch = useDispatch()
    const planGroups = useSelector((state) => state.plangroups.results)

    useEffect(() => {
        dispatch(getPlanGroups())
    }, [])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col px-0">
                        <h1 className="title">{ gettext('New Plan') }</h1>
                    </div>
                </div>
            </div>
            <PlanForm planGroups={planGroups}/>
        </>
    );
}

export default PlanCreate